<template>
  <a-modal
    v-model="visible"
    :title="title"
    :footer="null"
    width="80%"
    :keyboard="false"
    :maskClosable="false"
    :dialog-style="{ top: '20px' }"
  >
    <a-spin :spinning="loading">
      <div class="contract-box" v-html="artcCntnt"></div>
    </a-spin>
  </a-modal>
</template>
<script>
import { protocolList } from "@/api/lawTxt.js";
export default {
  name: "userService",
  data() {
    return {
      visible: false,
      loading: false,
      artcCntnt: "",
      lawValue: {},
      title: "",
      fileId: ""
    };
  },
  computed: {},
  methods: {
    open({ title, fileId, artcCntnt}) {
      this.title = title;
      this.fileId = fileId;
      this.artcCntnt = artcCntnt;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    borrowedContractList() {
      this.loading = true;
      let params;
      params = {
        fileId: this.fileId
      };
      protocolList(params)
        .then(res => {
          this.lawValue = res.data;
          this.artcCntnt = res.data.artcCntnt;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  },
  watch: {
  }
};
</script>
<style scoped>
.contract-box {
  height: 78vh;
  margin: 0 auto;
  margin-top: 30px;
  padding: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: auto;

}
</style>



// WEBPACK FOOTER //
// src/components/sign/serviceView.vue